import React from 'react';
import {
  HiredInsuranceCallCenterBagProtection,
  HiredInsuranceCallCenterIncomeProtection,
  HiredInsuranceCallCenterTakesCare,
  HiredInsuranceCancelAuto,
  HiredInsuranceCancelBagProtection,
  HiredInsuranceCancelFailBagProtection,
  HiredInsuranceCancelFailIncomeProtection,
  HiredInsuranceCancelFailTakesCare,
  HiredInsuranceCancelIncomeProtection,
  HiredInsuranceCancelSuccessBagProtection,
  HiredInsuranceCancelSuccessIncomeProtection,
  HiredInsuranceCancelSuccessTakesCare,
  HiredInsuranceCancelTakesCare,
  HiredInsuranceCoverageAuto,
  HiredInsuranceCoverageBagProtection,
  HiredInsuranceCoverageIncomeProtection,
  HiredInsuranceCoverageTakesCare,
  HiredInsuranceDetailsAuto,
  HiredInsuranceDetailsBagProtection,
  HiredInsuranceDetailsIncomeProtection,
  HiredInsuranceDetailsTakesCare,
  HiredInsuranceSinisterAuto,
} from '~/scenes';
import { Stack } from '../stackNavigation';

export const HiredInsuranceNavigation = (
  <Stack.Group>
    <Stack.Screen
      name="MarisaServicos_HiredInsuranceDetailsAuto"
      component={HiredInsuranceDetailsAuto}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceDetailsTakesCare"
      component={HiredInsuranceDetailsTakesCare}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceDetailsIncomeProtection"
      component={HiredInsuranceDetailsIncomeProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceDetailsBagProtection"
      component={HiredInsuranceDetailsBagProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCancelAuto"
      component={HiredInsuranceCancelAuto}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCancelTakesCare"
      component={HiredInsuranceCancelTakesCare}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCancelIncomeProtection"
      component={HiredInsuranceCancelIncomeProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCancelBagProtection"
      component={HiredInsuranceCancelBagProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCancelSuccessTakesCare"
      component={HiredInsuranceCancelSuccessTakesCare}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCancelSuccessIncomeProtection"
      component={HiredInsuranceCancelSuccessIncomeProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCancelSuccessBagProtection"
      component={HiredInsuranceCancelSuccessBagProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCancelFailTakesCare"
      component={HiredInsuranceCancelFailTakesCare}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCancelFailIncomeProtection"
      component={HiredInsuranceCancelFailIncomeProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCancelFailBagProtection"
      component={HiredInsuranceCancelFailBagProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCoverageAuto"
      component={HiredInsuranceCoverageAuto}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCoverageTakesCare"
      component={HiredInsuranceCoverageTakesCare}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCoverageIncomeProtection"
      component={HiredInsuranceCoverageIncomeProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCoverageBagProtection"
      component={HiredInsuranceCoverageBagProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCallCenterTakesCare"
      component={HiredInsuranceCallCenterTakesCare}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCallCenterIncomeProtection"
      component={HiredInsuranceCallCenterIncomeProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceCallCenterBagProtection"
      component={HiredInsuranceCallCenterBagProtection}
    />

    <Stack.Screen
      name="MarisaServicos_HiredInsuranceSinisterAuto"
      component={HiredInsuranceSinisterAuto}
    />
  </Stack.Group>
);
